/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import 'aisztheme/sass/animate.scss';

import React from 'react';
import {
  Button,
  Row,
  Col,
  Grid,
  Modal,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl';
import Toolbar from 'loracoms/Toolbar';
import Nvl from 'loracoms/LoadingVal';
import PageLoading from 'loracoms/PageLoading';
import IntlMsg from 'lorautils/intl/IntlMsg';
import deviceActions from 'loraactions/device';
import usageActions from 'loraactions/usage';
import { delDevice } from 'loraapi/lora_device';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import DeviceBriefPktTrend from '../DeviceBriefPktTrend';
import DeviceBriefData from '../DeviceBriefData';
import DeviceProps from '../DeviceProps';
import styles from './styles.scss';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  device: React.PropTypes.object.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  appId: React.PropTypes.string.isRequired,
  pushState: React.PropTypes.func.isRequired,
  basic: React.PropTypes.object.isRequired,
  delResult: React.PropTypes.object.isRequired,
  getNodesUsage: React.PropTypes.func.isRequired,
  appState: React.PropTypes.object.isRequired,
  replaceState: React.PropTypes.func.isRequired,
};

class DetailView extends React.Component {

  constructor(props) {
    super(props);
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.detailview');
    this.state = {
      device: props.device,
      basic: props.basic,
      appState: props.appState,
      latestData: [],
      dataDir: 'up',
      coordinate: `${props.device.lat},${props.device.lng}`,
      coordinateError: null,
      sendStatus: {},
      noExist: false,
    };
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const {
      device,
      basic,
      delResult,
      appId,
      pushState,
      appState,
    } = nextProps;
    if (device !== this.props.device) {
      this.setState({
        device,
        coordinate: `${device.lat}, ${device.lng}`,
      });
      const { status, error: { code } = {} } = device;
      if (status === 'failure' && code === 'NOTFOUND') {
        this.setState({ noExist: true });
      }
    }
    if (basic !== this.props.basic) {
      this.setState({ basic });
    }
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
    if (delResult !== this.props.delResult) {
      if (delResult.status === 'success') {
        pushState(`/application/${appId}`);
      }
    }
  }

  detail(key) {
    const { device } = this.state;
    const { status, data } = device;
    if (status === 'success') {
      return data[key];
    }
    if (status === 'failure') {
      return <i className="fa fa-exclamation-triangle" />;
    }
    return <i className="fa fa-spinner fa-spin" />;
  }

  handleDelete() {
    const { getNodesUsage } = this.props;
    delDevice(this.props.deviceId).then(() => {
      getNodesUsage();
      this.props.pushState(`/application/${this.props.appId}`);
    });
  }

  renderDeleteModal() {
    const { deviceId } = this.props;
    const { device: { data: { name } = {} } } = this.state;

    return (
      <Modal
        bsClass="aisz-modal-danger"
        show={this.state.showDelete}
        onHide={() => this.setState({ showDelete: false })}
      >
        <Modal.Header closeButton>
          <div className="text-center">
            <i className="fa fa-exclamation-triangle" aria-hidden="true" />
            {' '}
            {this.intlMsg.msg('delete.modalheader')}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p>
              { this.intlMsg.msg('delete.confirm') }
              <strong>
                {name}({deviceId})
              </strong> ?
            </p>
            <div>
              <Button
                bsStyle="aisz-warning"
                onClick={() => this.setState({ showDelete: false })}
              >
                <i className="fa fa-repeat" aria-hidden="true" />
                {' '}
                { this.intlMsg.msg('delete.cancelbtn') }
              </Button>
              {' '}
              <Button bsStyle="aisz-danger" onClick={this.handleDelete}>
                <i className="fa fa-trash-o" aria-hidden="true" />
                {' '}
                { this.intlMsg.msg('delete.confirmbtn') }
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  renderToolbar() {
    const { appId } = this.props;
    const { device, appState } = this.state;
    const {
      status,
      data: { name, deveui } = {},
    } = device;
    const {
      status: appStatus,
      data: { name: appName } = {},
    } = appState;

    let devName;
    if (name === '') {
      devName = <Nvl val={deveui} formatter={normalizeDevEUI} status={status} />;
    } else {
      devName = <Nvl val={name} status={status} />;
    }

    const breadcrumb = [{
      content: <FormattedMessage id="application.breadcrumb.application" />,
      onClick: () => this.props.pushState('/application'),
    }, {
      content: <Nvl val={appName} status={appStatus} />,
      onClick: () => this.props.replaceState(`/application/${appId}`),
    }, {
      content: devName,
      active: true,
    }];

    const rightTools = [{
      type: 'buttons',
      buttons: [(
        <Button bsStyle="aisz-danger" onClick={() => this.setState({ showDelete: true })} >
          { this.intlMsg.msg('delete.btn') }
          {' '}
          <i className="fa fa-trash-o" aria-hidden="true" />
        </Button>
      )],
    }];

    return <Toolbar breadcrumb={breadcrumb} rightTools={rightTools} />;
  }

  render() {
    const { deviceId, appId } = this.props;
    const { basic, noExist } = this.state;
    if (basic.status !== 'success') {
      return <PageLoading />;
    }

    return (
      <div>
        <Grid fluid>
          <Row>
            <Col md={12}>
              {this.renderToolbar()}
            </Col>
          </Row>
          {noExist &&
            <div className={styles.noDevice}>
              <h3>
                {this.intlMsg.msg('nodevice')}
              </h3>
              <div className={styles.desc}>
                {this.intlMsg.msg('nodevice.tips')}
              </div>
            </div>
          }
          {!noExist &&
          <Row>
            <Col md={8} className="collapse-right">
              <DeviceBriefPktTrend appId={appId} deviceId={deviceId} />
              <DeviceBriefData appId={appId} deviceId={deviceId} />
            </Col>
            <Col md={4}>
              <DeviceProps deviceId={deviceId} />
            </Col>
          </Row>
          }
        </Grid>
        <div>
          {this.renderDeleteModal()}
        </div>
      </div>
    );
  }
}

DetailView.propTypes = propTypes;


const mapStateToProps = (state, ownProps) => ({
  device: state.device.getDevice || {},
  basic: state.org.basic || {},
  delResult: state.device.deleteDevice,
  appId: ownProps.params.appId,
  deviceId: ownProps.params.deviceId,
  path: ownProps.location.pathname,
  appState: state.app.getApp,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  replaceState: routerActions.replace,
  getDevice: deviceActions.getDevice,
  deleteDevice: deviceActions.deleteDevice,
  getNodesUsage: usageActions.nodes,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DetailView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/DetailView/index.jsx